export enum AssessmentTypeEnum {
    Standard = 1,
    Threesixty = 2
}